import { render, staticRenderFns } from "./SunsetsApp.vue?vue&type=template&id=4f487c4f&scoped=true&"
import script from "./SunsetsApp.vue?vue&type=script&lang=ts&"
export * from "./SunsetsApp.vue?vue&type=script&lang=ts&"
import style0 from "./SunsetsApp.vue?vue&type=style&index=0&id=4f487c4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f487c4f",
  null
  
)

export default component.exports